import { createApp } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";
import VueCreditCardValidation from "vue-credit-card-validation";

import "@/core/plugins/prismjs";
import { vMaska } from "maska/vue";
import RoleCheck from "@/store/modules/RoleCheckModule";
const app = createApp(App);

const roleCheckInstance = new RoleCheck();
app.config.globalProperties.$role = roleCheckInstance;

app.use(store);
app.use(router);
app.use(ElementPlus);
app.directive("maska", vMaska);
app.use(VueCreditCardValidation);

ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

app.mount("#app");
